import { Card } from "antd";
import { CardProps, MetaProps } from "./type";

const { Meta } = Card;
function AntCard(props: CardProps) {
  return <Card {...props} />;
}
function AntCardMeta(props: MetaProps) {
  return <Meta {...props} />;
}

export { AntCard as Card, AntCardMeta as Meta };
